import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-engage-gray1 border-t border-engage-gray2 pt-16 pb-8" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-32">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-33">
            <Link to="/" className="flex items-center mb-4" data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/rubaJbsbfYXRnY6rEG65oJ/Logo_Engage_Media_white.png" alt="Engage Media" className="h-16 w-auto" data-id="element-35" />
            </Link>
            <p className="text-engage-gray4 max-w-xs mx-auto md:mx-0" data-id="element-36">
              A performance growth agency building systems that move people,
              drive action, and generate real revenue.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col space-y-3 items-center md:items-start text-center md:text-left" data-id="element-37">
            <h4 className="text-engage-white font-semibold mb-2" data-id="element-38">Navigation</h4>
            <Link to="/" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-39">
              Home
            </Link>
            <Link to="/services" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-40">
              Services
            </Link>
            <Link to="/case-studies" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-41">
              Case Studies
            </Link>
            <Link to="/contact" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-42">
              Contact
            </Link>
            <Link to="/careers" className="text-lg md:text-base text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-43">
              Careers
            </Link>
          </div>

          {/* Contact & Social */}
          <div className="flex flex-col space-y-4 items-center md:items-start text-center md:text-left" data-id="element-44">
            <h4 className="text-engage-white font-semibold mb-2" data-id="element-45">Connect</h4>
            <a href="mailto:contact@engagemedia.group" className="flex items-center justify-center md:justify-start text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-46">
              <Mail size={18} className="mr-2" data-id="element-47" />
              contact@engagemedia.group
            </a>
            <a href="https://instagram.com/engagemedia.us" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start text-engage-gray4 hover:text-engage-yellow transition-colors" data-id="element-48">
              <Instagram size={18} className="mr-2" data-id="element-49" />
              @engagemedia.us
            </a>
          </div>
        </div>

        <div className="border-t border-engage-gray2 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-engage-gray5 text-center md:text-left" data-id="element-50">
          <p data-id="element-51">© 2026 Engage Media. All rights reserved.</p>
          <div className="mt-4 md:mt-0 space-x-4" data-id="element-52">
            <Link to="#" className="hover:text-engage-white transition-colors" data-id="element-53">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-engage-white transition-colors" data-id="element-54">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}